'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridProps = undefined;

var _componentHelpers = require('../../utils/component-helpers');

var gridProps = exports.gridProps = function gridProps() {
  var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments[1];

  return {
    gridStyles: styles.grid,
    styles: styles.hero,
    content: [{
      leftCell: props.heroAnnualFeeLabel,
      rightCell: (0, _componentHelpers.potentialHtml)((0, _componentHelpers.concactDescStr)(props.cardAnnualFee, '<br/>'))
    }, {
      leftCell: props.heroSuppAnnualFeeLabel,
      rightCell: (0, _componentHelpers.potentialHtml)((0, _componentHelpers.concactDescStr)(props.suppAnnualFee, '<br/>'))
    }, {
      leftCell: props.cardTypeLabel === 'TAN/TAEG:' ? (0, _componentHelpers.boldDescLabel)(props.cardTypeLabel) : props.cardTypeLabel,
      rightCell: (0, _componentHelpers.potentialHtml)((0, _componentHelpers.concactDescStr)(props.cardType.desc, '<br/>'))
    }, {
      leftCell: props.heroBonusOfferLabel,
      rightCell: (0, _componentHelpers.potentialHtml)(props.bonusOffer, '<br/>')
    }].filter(function (section) {
      return section.leftCell;
    }),
    title: (0, _componentHelpers.potentialHtml)(props.cardTitle),
    subtitle: (0, _componentHelpers.potentialHtml)((0, _componentHelpers.concactDescStr)(props.cardDesc))
  };
};